import { modalRenderer } from '~/modal/modalRendererRegistry';
import { MapMarkerColumnsDisplaySettingsContainer } from './mapMarkerColumnsDisplaySettings.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    MapMarkerColumnsDisplaySettings: undefined;
  }
}

modalRenderer.register('MapMarkerColumnsDisplaySettings', MapMarkerColumnsDisplaySettingsContainer);
